import { useContext as a } from "react";
import { a as f } from "./domains-6461a203.js";
import { a as v } from "./FeatureProvider-eea49aec.js";
import { F as P } from "./FeatureProvider-eea49aec.js";
import "./jsx-runtime-721af1ab.js";
import "@tanstack/react-query";
import "./useAccount-9a3d6a50.js";
import "./lodash-3345fe65.js";
import "./myasurion-shared.mixpanel.es.js";
import "mixpanel-browser";
function s(o, i) {
  if (o)
    for (const e of o) {
      const t = d(e, i);
      if (t)
        return t;
    }
}
function d(o, i) {
  if (o.key === i)
    return o;
  if (o.options)
    for (const e of o.options) {
      const t = d(e, i);
      if (t && "isEnabled" in t)
        return t.isEnabled === !0 ? t : void 0;
    }
}
const h = (o) => {
  var p, c;
  const i = a(v);
  if (i === void 0)
    throw new Error("useFeature must be used within a Feature Provider");
  const e = f(), { features: t, isInitialized: m } = i, r = (p = t == null ? void 0 : t.featureList) == null ? void 0 : p[e ?? "device_protection"], n = r == null ? void 0 : r.find((u) => (u == null ? void 0 : u.key) === o);
  return {
    remoteConfig: t,
    isOn: !!n,
    version: n == null ? void 0 : n.version,
    isFeatureOn: !!s(r, o),
    feature: s(r, o),
    featureVersion: (c = s(r, o)) == null ? void 0 : c.version,
    findValue: s,
    isFeatureInitialized: m
  };
};
export {
  P as FeatureProvider,
  h as useFeature
};
